require("./assets/styles/index.scss");

import isMobile from "ismobilejs";

import Vue from "./init";

import Vuebar from "vuebar";
import VueScrollTo from "vue-scrollto";
import Meta from "vue-meta";
import VueLazyload from "vue-lazyload";
import VeeValidate from "vee-validate";

Vue.use(VeeValidate);

Vue.use(Vuebar);

Vue.use(VueScrollTo, {
  offset: -80,
  duration: 500,
  easing: "ease",
});

Vue.use(Meta);

Vue.use(VueLazyload, {
  loading: "",
  observer: true,
  lazyComponent: true,
});

import VueFractionGrid from "vue-fraction-grid";

Vue.use(VueFractionGrid, {
  container: "1500px",
  gutter: "24px",
  approach: "mobile-first",
  breakpoints: {
    compact: "300px 799px",
    tablet: "800px 1450px",
  },
});

import store from "./store";
import router from "./router";

// Check if it's mobile UA
store.commit("settings/isMobile", isMobile.any);

import VueCarousel from "vue-carousel";

Vue.use(VueCarousel, {
  container: document.getElementsByTagName("body"),
});

import App from "./App.vue";

// disable annoying production tip in console
Vue.config.productionTip = false;

/* eslint-disable no-new */
let vueInstance = new Vue({
  el: "#app",
  store,
  router,
  render: (h) => h(App),
});

export default vueInstance;
